/**
 * 튜토리얼 인터랙션 게이트 — 순수 결정 함수 (Phaser/런타임 의존 0).
 *
 * 튜토리얼 진행 중 "정해진(허용된) 인터랙션만" 통과시키고 나머지 게임 인터랙션은 차단하기 위한 게이트.
 * 게임 콜백 사이트(예: 그리드 잠금셀 클릭)가 실행 직전 이 함수를 조회해, false면 동작을 무시한다.
 * (결정만 하고 부수효과는 호출자가 수행 — `resolveTabTutorialStart`와 동일한 순수 분리 컨벤션.)
 *
 * 정책:
 * - 튜토리얼 비활성 → 항상 허용(게임 정상 플레이).
 * - `allowedActions` 빈 배열 → 항상 허용(미설정 스텝 = 무제한, 기존 회귀 0 / opt-in).
 * - 비어있지 않으면 → 목록에 포함된 actionKey만 허용.
 *
 * @param active 튜토리얼 진행 중인지 (`TutorialRunner.isActive`).
 * @param allowedActions 현재 스텝이 허용한 인터랙션 키 목록 (`TutorialStep.allowedActions`).
 * @param actionKey 조회하려는 인터랙션 키 (예: "grid.unlock").
 */
export function isInteractionAllowed(
  active: boolean,
  allowedActions: readonly string[],
  actionKey: string,
): boolean {
  if (!active) return true;
  if (allowedActions.length === 0) return true;
  return allowedActions.includes(actionKey);
}
